<template>
  <div class="ns-card">
    <VCard :class="context" class="card-type">
      <VCardTitle primary-title>
        <div class="header-wrapper">
          <div class="header-left-content">
            <NsIcon
              v-if="headerIcon.length > 0"
              class="title-icon"
              :color="headerColor"
              :icon-name="headerIcon"
              size="icon-md"
            /><slot name="header"></slot>
          </div>
          <div class="header-right-content">
            <button
              v-if="hasAction"
              class="action-button"
              @click="$emit('onActionClick', $event.target.value)"
            >
              <NsIcon
                class="nsicon"
                :class="actionString.length > 0 ? '' : 'no-text'"
                :color="color"
                :icon-name="actionIcon"
                size="icon-sm"
              />
              <span
                v-if="actionString.length > 0"
                class="subtitle-small"
                :style="{ color: color }"
                >{{ actionString }}</span
              >
            </button>
          </div>
        </div>
      </VCardTitle>
      <VContainer fluid class="card-body">
        <slot name="content"></slot>
      </VContainer>
    </VCard>
  </div>
</template>
<script>
/**
 * Original Author: Pilar Rust
 * Original Team: Unidrythons
 */
import { NsIcon } from '@nuskin/ns-icon';
import { VCard, VCardTitle, VContainer } from 'vuetify/lib';

export default {
  name: 'NsCard',
  components: { NsIcon, VCard, VCardTitle, VContainer },
  props: {
    hasAction: {
      type: Boolean,
      required: false,
      default: false,
    },
    actionIcon: {
      type: String,
      required: false,
      default: 'icon-close',
    },
    actionString: {
      type: String,
      required: false,
      default: '',
    },
    color: {
      type: String,
      required: false,
      default: '#7123D9',
    },
    context: {
      type: String,
      default: '',
      required: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    headerColor() {
      switch (this.context) {
        case 'danger':
          return '#C81D1D';
        case 'info':
          return '#3783B9';
        case 'success':
          return '#5BAC85';
        case 'warning':
          return '#FD983B';
        default:
          return '#3783B9';
      }
    },
    headerIcon() {
      switch (this.context) {
        case 'danger':
          return 'icon-exclamation';
        case 'success':
          return 'icon-success-filled';
        case 'warning':
          return 'icon-warning-filled';
        case 'info':
          return 'icon-info-filled';
        default:
          return '';
      }
    },
  },
};
</script>
<style scoped lang="scss">
@use 'sass:map';
@use '~@nuskin/ns-core-styles/src/scss/buttons';
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";
@use "~@nuskin/ns-core-styles/src/scss/global.mixins";

.ns-card {
  .v-card {
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
    &.card-type {
      &::before {
        width: 10px;
        content: '';
        height: 100%;
        display: block;
        position: absolute;
        left: 0;
        top: 0;
      }
      &.warning {
        padding-left: 10px;
        &::before {
          background: #fd983b;
        }
      }
      &.danger {
        padding-left: 10px;
        &::before {
          background: #c81d1d;
        }
      }
      &.info {
        padding-left: 10px;
        &::before {
          background: #3783b9;
        }
      }
      &.success {
        padding-left: 10px;
        &::before {
          background: #5bac85;
        }
      }
    }
  }
  .v-card__title {
    padding: 20px;
  }
  .container {
    padding: 0 20px 20px;
  }
  .header-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .header-left-content {
      @include global.heading-2();
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .title-icon {
        margin-right: 5px;
      }
    }
    .header-right-content {
      margin-left: auto;
      button {
        &.action-button {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-flow: row nowrap !important;
          svg {
            margin-right: 8px;
            height: 16px;
            width: 16px;
            &.no-text {
              margin-right: 0;
            }
          }
          span {
            &.subtitle-small {
              font-weight: 600;
              font-size: 16px;
              line-height: 30px;
              font-family: map.get(
                typographyVariables.$typography,
                font-family-primary
              );
            }
          }
        }
      }
    }
  }
  .card-body {
    @include global.paragraph-m();
  }
}
</style>
